// extracted by mini-css-extract-plugin
export var editInput = "_g8-0";
export var editInputCompact = "_g8-2";
export var editInputLarge = "_g8-1";
export var editInputSmall = "_g8-3";